<template>
  <div class="users-list-page" v-loading="loading">
    <el-card class="app-table-container" :body-style="{ padding: '20px' }">
      <div slot="header">
        <div class="card-header">
          <Search
            ref="search"
            class="feedback-tagsTree-search"
            @listSearchEvn="listSearchEvn"
          ></Search>
          <button class="global-button-style" @click="append()">
            {{ $t("commonMsg.add") }}
          </button>
        </div>
      </div>
      <div class="tree-wrap" v-bar>
        <div>
          <el-tree
            ref="tree"
            :data="treeData"
            draggable
            node-key="_id"
            :props="defaultProps"
            :default-expanded-keys="defaultTagsTreeExpanded"
            empty-text="暂无数据"
            highlight-current
            @node-expand="nodeExpand"
            @node-collapse="nodeCollapse"
            @node-drop="handleDrop"
            :allow-drop="allowDrop"
          >
            <div class="feedbackTag-tree-node" slot-scope="{ node, data }">
              <div class="feedbackTag-tree-node-left">
                <p class="feedbackTag-tree-node-title">{{ data.value }}</p>
                <p
                  v-if="data.descendantCount"
                  class="feedbackTag-tree-node-count"
                >
                  （{{ data.descendantCount }}）
                </p>
              </div>
              <span>
                <el-button
                  v-if="
                    (!data.parent || data.parent === null) && node.level === 1
                  "
                  type="text"
                  size="mini"
                  @click.stop="append(data)"
                >
                  新增
                </el-button>
                <el-button type="text" size="mini" @click.stop="updated(data)">
                  更新
                </el-button>
                <el-button type="text" size="mini" @click.stop="remove(data)">
                  删除
                </el-button>
              </span>
            </div>
          </el-tree>
        </div>
      </div>
    </el-card>
    <el-dialog :visible.sync="isAdd" width="30%" center>
      <div>
        <h4>标签名称</h4>
        <el-input
          v-model.trim="tagStr"
          placeholder="(添加多个标签用\隔开)"
          clearable
        ></el-input>
      </div>
      <div slot="footer">
        <el-button @click="isAdd = false">取消</el-button>
        <el-button type="primary" @click="confirm">确认</el-button>
      </div>
    </el-dialog>
    <el-dialog :visible.sync="isUpdate" width="30%" center>
      <div>
        <h4>标签名称</h4>
        <el-input
          v-model.trim="params.value"
          placeholder=""
          clearable
        ></el-input>
      </div>
      <div slot="footer">
        <el-button @click="isUpdate = false">取消</el-button>
        <el-button type="primary" @click="confirm">确认</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Search from "@/components/listSearch";
export default {
  props: {
    category: {
      type: String,
      default: "funct"
    }
  },
  components: {
    Search
  },
  data() {
    return {
      treeData: [],
      defaultProps: {
        children: "children",
        label: "value"
      },
      total: 0,
      selectData: [],
      params: {
        category: ""
      },
      isAdd: false,
      isUpdate: false,
      action: "",
      tagParent: null,
      tagStr: "",
      loading: false,
      defaultTagsTreeExpanded: [],
      searchVal: ""
    };
  },
  methods: {
    async getList() {
      try {
        this.loading = true;
        let res = await this.$http.getFeedbackTagsTree({
          category: this.category,
          value: this.searchVal
        });
        this.treeData = res.data[0].list;
        this.defaultTagsTreeExpanded =
          JSON.parse(localStorage.getItem("defaultTagsTreeExpanded")) || [];
        this.loading = false;
      } catch (error) {
        this.loading = false;
      }
    },

    nodeExpand(data) {
      this.defaultTagsTreeExpanded = [
        ...this.defaultTagsTreeExpanded,
        data._id
      ];
      localStorage.setItem(
        "defaultTagsTreeExpanded",
        JSON.stringify(this.defaultTagsTreeExpanded)
      );
    },
    nodeCollapse(data) {
      this.filterExpand(data);
      localStorage.setItem(
        "defaultTagsTreeExpanded",
        JSON.stringify(this.defaultTagsTreeExpanded)
      );
    },

    filterExpand(data) {
      if (this.defaultTagsTreeExpanded.includes(data._id)) {
        let idx = this.defaultTagsTreeExpanded.findIndex(
          item => item === data._id
        );
        if (idx != -1) {
          this.defaultTagsTreeExpanded.splice(idx, 1);
        }
      }
      if (data.children.length) {
        for (let item of data.children) {
          this.filterExpand(item);
        }
      }
    },

    allowDrop(draggingNode, dropNode, type) {
      if (dropNode.data.parent || dropNode.data.parent !== null) {
        return type !== "inner";
      } else {
        return true;
      }
    },

    async handleDrop(draggingNode, dropNode, type) {
      let draggingData = draggingNode.data;
      let dropData = dropNode.data;
      let list, index;

      if (type === "inner") {
        draggingData.parent = dropData._id;
        draggingData.ordinal = new Date().getTime();
      } else {
        if (dropData.parent || dropData.parent !== null) {
          let parent = this.treeData.find(item => item._id === dropData.parent);
          list = parent.children;
        } else {
          list = this.treeData;
        }

        index = list.findIndex(item => item._id === draggingData._id);

        // 跨级拖拽
        if (draggingData.parent !== dropData.parent) {
          draggingData.parent = dropData.parent;
        }

        if (index === 0) {
          // 拖到第一位置
          let timeStamp = new Date().getTime();
          draggingData.ordinal = (list[index + 1].ordinal + timeStamp) / 2;
        } else if (index === list.length - 1) {
          // 拖到最后位置
          let oldLastItem = list[index - 1];
          draggingData.ordinal = oldLastItem.ordinal;
          oldLastItem.ordinal =
            (oldLastItem.ordinal + list[index - 2].ordinal) / 2;
          this.params = oldLastItem;
          await this.updateFeedbackTags();
        } else {
          draggingData.ordinal =
            (list[index + 1].ordinal + list[index - 1].ordinal) / 2;
        }
      }

      this.params = draggingData;
      await this.updateFeedbackTags();
    },

    confirm() {
      if (this.action === "add") {
        this.addFeedbackTags();
      } else {
        this.updateFeedbackTags();
      }
    },

    append(data = null) {
      this.action = "add";
      this.tagStr = "";
      this.tagParent = data ? data._id : null;
      this.isAdd = true;
    },

    async addFeedbackTags() {
      let arr = this.tagStr.split("\\").filter(item => item && item.trim());
      if (!arr.length) return;
      for (let item of arr) {
        let params = {
          parent: this.tagParent,
          key: new Date().getTime(),
          value: item,
          category: this.category
        };
        await this.$http.addFeedbackTags(params);
      }
      this.getList();
      this.isAdd = false;
    },

    updated(data) {
      this.action = "updated";
      this.params = Object.assign({}, data);
      this.isUpdate = true;
    },

    async updateFeedbackTags() {
      if (!this.params.value) return;
      await this.$http.updateFeedbackTags(this.params._id, this.params);
      this.getList();
      this.isUpdate = false;
    },

    async remove(data) {
      await this.$confirm(null, "确认删除？", {
        confirmButtonText: this.$t("commonMsg.confirm"),
        cancelButtonText: this.$t("commonMsg.cancel"),
        showClose: false,
        center: true
      });
      await this.$http.delFeedbackTags(data._id);
      this.getList();
    },

    listSearchEvn(val) {
      this.searchVal = val;
      this.getList();
    }
  },
  watch: {
    category() {
      localStorage.removeItem("defaultTagsTreeExpanded");
      this.params.category = this.category;
      this.searchVal = "";
      this.$refs.search.clearValue();
      this.getList();
    }
  },
  mounted() {
    this.params.category = this.category;
    this.getList();
  }
};
</script>

<style lang="scss">
.users-list-page {
  height: 100%;
  display: flex;
  flex-direction: column;
  .left-part {
    flex: 1;
    display: flex;
    align-items: center;
    > span {
      margin-right: 10px;
      font-size: 16px;
    }
    .global-button-style {
      margin: 0;
    }
  }
  .card-header {
    display: flex;
    justify-content: flex-end;
    align-items: center;
  }
  .tree-wrap {
    flex: 1;
    display: flex;
    .el-tree-node__content:hover {
      background-color: #f5eae6 !important;
    }
    .feedbackTag-tree-node {
      flex: 1;
      display: flex;
      align-items: center;
      justify-content: space-between;
      font-size: 14px;
      padding-right: 8px;
      .feedbackTag-tree-node-left {
        display: flex;
        align-items: center;
        .feedbackTag-tree-node-title {
          padding: 2px 4px;
        }
        .feedbackTag-tree-node-count {
          color: red;
        }
      }
    }
  }
}
</style>
